import Api from './api';
import APIClient from './v2';

export default Api;

// APIClient is exposed in this way in order to do not break backward compatibility
export { APIClient };
